<template>
  <div class="home_conteiner">
    <div class="date">
      <dp-datepicker
        range
        :disabled-date="disabledBeforeTodayAndAfterAWeek"
        :shortcuts="shortcuts"
        :lang="langFile"
        inputType="secondary"
        :placeholder="
          isShowDatetext
            ? this.lastWeektext + '-' + this.todaytext
            : $t('pageLanguage.startdate') + '-' + $t('pageLanguage.enddate')
        "
        class="datepicker"
        v-model="date"
      ></dp-datepicker>
    </div>
    <div></div>
    <div class="table">
      <div class="table_header">
        <div class="table_header-left">STATISTIK</div>
        <div class="table_header-right">
          <div class="right-title" v-if="anzahlcount < 1">
            {{ $t("pageLanguage.count") }}: {{ getCliendListDataCount }}
          </div>
          <div class="right-title" v-else>
            {{ $t("pageLanguage.count") }}: {{ anzahlcount }}/{{
              getCliendListDataCount
            }}
          </div>
        </div>
      </div>
      <div
        class="no-Document"
        v-if="isShowFilterimg == true || isShowNoDataimg == true"
      >
        <img
          v-if="
            isLoading == false &&
              isShowFilterimg == true &&
              isShowNoDataimg == false
          "
          class="nodataimgFilter"
          src="../assets/images/illustration.svg"
          alt=""
        />
        <img
          v-if="
            isLoading == false &&
              isShowFilterimg == false &&
              isShowNoDataimg == true
          "
          class="nodataimgData"
          src="../assets/images/illustration2.svg"
          alt=""
        />
        <p
          class="descirpt1"
          v-if="
            isShowFilterimg == true && isShowNoDataimg == false && !isLoading
          "
        >
          Für diesen Mandanten gibt es leider keine Aufzeichnungen.
        </p>
        <p
          class="descirpt1"
          v-if="
            isShowFilterimg == false && isShowNoDataimg == true && !isLoading
          "
        >
          Heute wurden noch keine Dokumente digitalisiert.
        </p>
        <p
          class="descirpt2"
          v-if="
            isShowFilterimg == true && isShowNoDataimg == false && !isLoading
          "
        >
          Am besten direkt im Shop anlegen und die ersten Dokumente
          digitalisieren.
        </p>
        <p
          class="descirpt2"
          v-if="
            isShowFilterimg == false && isShowNoDataimg == true && !isLoading
          "
        >
          Also legen Sie direkt los mit einer unserer zahireichen Möglichkeiten
        </p>
      </div>
      <div class="detail">
        <dp-loader
          v-if="isLoading"
          strokeWidth="3"
          size="xlarge"
          strokeColor="#174171"
        ></dp-loader>
        <dp-table
          noDataText=" "
          class="table"
          :class="[
            { 'table-expand': getIsExpand },
            { 'table-refresh-icon': tableRefreshIcon }
          ]"
          :columns="columns"
          @keyup.enter="filterRemote"
          @on-selection-change="anzahlCount"
          :data="getCliendListData"
          :height="h"
        >
          <template slot="documentDate" slot-scope="{ row }">
            {{ convertDatepickerDate(row.documentDate) }}
          </template>
        </dp-table>
      </div>
    </div>
    <div class="pagination">
      <dp-pagination
        :total="totalPage"
        show-sizer
        :sizerPrefixText="$t('pageLanguage.show')"
        :sizerSuffixText="$t('pageLanguage.records')"
        @on-page-size-change="perPage = $event"
        @on-change="currentPage = $event"
      >
      </dp-pagination>
      <div class="home-dothSupport-item">
        <div class="home-doth">
          <i class="dp-icon-doth"></i>
        </div>
        <div
          id="zeWidget"
          role="button"
          class="home-support animate fadeInUp text-dark-gray-1000 fixed text-semibold font-semibold bg-transition d-flex justify-content-center align-items-center"
          onclick="openWidget()"
        >
          <i class="dp-icon-help mr-2 text-xl support-icon"></i>
          Support
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableExpand from "../components/Card/Expand";
import { forStrings } from "../_helper/filters.js";
import { cliendList } from "../_helper/apiserve";

export default {
  data() {
    return {
      tableRefreshIcon: false,
      date: [],
      h: window.innerHeight - 230,
      quary: "",
      isLoading: true,
      isShowNoDataimg: false,
      isShowFilterimg: false,
      isUseFilterQuary: false,
      isUseDatepicker: false,
      isShowDatetext: true,
      startDate: "",
      today: "",
      todaytext: "",
      lastWeek: "",
      lastWeektext: "",
      endDate: "",
      anzahlcount: "",
      checkedRows: "",
      ccquary: "",
      ccoption: "",
      namequary: "",
      nameoption: "",
      columns: [],
      langFile: {
        formatLocale: {
          months: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
          ],
          // MMM
          monthsShort: [
            "Jan",
            "Feb",
            "März",
            "Apr",
            "Mai",
            "Juni",
            "Juli",
            "Aug",
            "Sept",
            "Okt",
            "Nov",
            "Dez"
          ],
          // dddd
          weekdays: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
          ],
          // ddd
          weekdaysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
          // dd
          weekdaysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          firstDayOfWeek: 1
        }
      },
      quaryname: "",
      quarycc: "",
      quaryStartDate: "",
      quaryEndDate: "",
      pageTotal: "",
      paginationTotal: null,
      perPage: 10,
      currentPage: 1,
      getPageData: "",

      shortcuts: [
        {
          text: this.$t("pageLanguage.Last_three_days"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 3 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        },
        {
          text: this.$t("pageLanguage.Last_seven_days"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        },
        {
          text: this.$t("pageLanguage.Last_month"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 30 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        }
      ]
    };
  },

  methods: {
    async apiMethods() {
      try {
        if (
          this.quarycc != "" &&
          this.quarycc != null &&
          this.quaryname != "" &&
          this.quaryname != null &&
          this.quaryStartDate != "" &&
          this.quaryStartDate != null &&
          this.quaryEndDate != "" &&
          this.quaryEndDate != null
        ) {
          const res = await cliendList(
            this.quarycc,
            this.ccoption,
            this.quaryname,
            this.nameoption,
            this.quaryStartDate,
            this.quaryEndDate,
            this.getPageData
          );
          const result = await res.json();
          this.$store.dispatch("addRepoClientList", result);
          this.todaytext = this.convertDatepickerDate(this.quaryEndDate);
          this.lastWeektext = this.convertDatepickerDate(this.quaryStartDate);
        } else {
          const res = await cliendList(
            this.ccquary,
            this.ccoption,
            this.namequary,
            this.nameoption,
            this.startDate,
            this.endDate,
            this.getPageData
          );
          const result = await res.json();
          if (result.status == "successful") {
            this.$store.dispatch("addRepoClientList", result);
          } else {
            this.$store.dispatch("addRepoClientList", "");
            if (
              this.$store.getters.showRepoClientList.data == null &&
              this.isUseFilterQuary == false &&
              this.isUseDatepicker == false
            ) {
              this.isLoading = false;
              this.isShowNoDataimg = true;
              this.isShowFilterimg = false;
            }

            if (this.isUseDatepicker == true) {
              this.isLoading = false;
              this.isShowNoDataimg = false;
              this.isShowFilterimg = true;
              this.isUseDatepicker = false;
            }

            if (this.isUseFilterQuary == true) {
              this.isLoading = false;
              this.isShowNoDataimg = false;
              this.isShowFilterimg = true;
            }
          }
        }
      } catch (e) {
        console.log("error", e);
      }
    },
    convertDatepickerDate(date) {
      if (date == null) return null;
      else {
        date = new Date(date);
        var dateStr =
          ("00" + date.getDate()).slice(-2) +
          "." +
          ("00" + (date.getMonth() + 1)).slice(-2) +
          "." +
          date.getFullYear();
        return dateStr;
      }
    },
    convertDateStart(date) {
      if (date == null) return null;
      else {
        date = new Date(date);
        var dateStr =
          date.getFullYear() +
          "-" +
          ("00" + (date.getMonth() + 1)).slice(-2) +
          "-" +
          ("00" + date.getDate()).slice(-2) +
          " " +
          "00:00:01";
        return dateStr;
      }
    },
    convertDateFinish(date) {
      if (date == null) return null;
      else {
        date = new Date(date);
        var dateStr =
          date.getFullYear() +
          "-" +
          ("00" + (date.getMonth() + 1)).slice(-2) +
          "-" +
          ("00" + date.getDate()).slice(-2) +
          " " +
          "23:59:59";
        return dateStr;
      }
    },
    anzahlCount(selected) {
      this.checkedRows = selected;
      this.anzahlcount = this.checkedRows.length;
    },
    startToOneWeekFilter() {
      this.today = new Date();
      this.endDate = this.convertDateFinish(this.today);
      this.startDate = this.convertDateStart(this.today);
      this.today = this.convertDateFinish(this.today);
      this.todaytext = this.convertDatepickerDate(this.today);
      this.lastWeek = this.convertDateStart(this.today);
      this.lastWeektext = this.convertDatepickerDate(this.today);
      localStorage.setItem("today", this.today);
      localStorage.setItem("lastWeek", this.today);
    },
    getQuary() {
      if (
        localStorage.getItem("quaryCc") != null &&
        localStorage.getItem("quaryCc") != ""
      ) {
        this.quarycc = localStorage.getItem("quaryCc");
        this.quaryname = localStorage.getItem("quaryName");
        this.quaryStartDate = localStorage.getItem("quaryStartDate");
        this.quaryEndDate = localStorage.getItem("quaryEndDate");
        this.lastWeektext = this.convertDatepickerDate(
          localStorage.getItem("quaryStartDate")
        );
        this.todaytext = this.convertDatepickerDate(
          localStorage.getItem("quaryEndDate")
        );
      } else if (this.$route.query.name != null) {
        this.quarycc = this.$route.query.cc;
        this.quaryname = this.$route.query.name;
        this.quaryStartDate = this.$route.query.startdate;
        this.quaryEndDate = this.$route.query.enddate;
        this.lastWeektext = this.convertDatepickerDate(
          this.$route.query.startdate
        );
        this.todaytext = this.convertDatepickerDate(this.$route.query.enddate);
      }
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      date = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > new Date(today.getTime());
    },
    sleep(ms) {
      this.isLoading = true;
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  computed: {
    getStatus() {
      return this.$store.getters.showStatus;
    },
    getIsExpand() {
      return this.$store.getters.showExpand;
    },
    getCliendListData() {
      return this.$store.getters.showRepoClientList.data;
    },
    getCliendListDataCount() {
      return this.$store.getters.showRepoClientList.count;
    },

    totalPage() {
      return this.$store.getters.showRepoClientList.count;
    },
    page() {
      return this.$store.getters.showRepoClientList.page;
    },
    LanguagePack() {
      return this.$store.getters.getLang;
    }
  },
  watch: {
    LanguagePack() {
      this.columns = [
        {
          type: "selection",
          width: 40,
          align: "center"
        },

        {
          filteredValue: ["ie"],
          title: this.$t("pageLanguage.consultant_no_client_no"),
          key: "cc",
          resizable: true,
          align: "left",
          sortable: true,
          search: true,
          searchQuery: this.filterQuery,
          filterMultiple: false,
          filters: forStrings,
          filterRemote(option, query) {
            this.ccquary = query;
            this.ccoption = option;
            this.filterQuery = query;
            this.isUseFilterQuary = true;
            this.filterQueryApi();
          }
        },
        {
          filteredValue: ["ie"],
          tooltip: true,
          title: this.$t("pageLanguage.client_name"),
          key: "name",
          resizable: true,
          align: "left",
          sortable: true,
          search: true,
          searchQuery: this.filterQuery,
          filterMultiple: false,
          filters: forStrings,
          filterRemote(option, query) {
            this.namequary = query;
            this.nameoption = option;
            this.filterQuery = query;
            this.isUseFilterQuary = true;
            this.filterQueryApi();
          }
        },
        {
          title: this.$t("pageLanguage.last_upload_on"),
          key: "documentDate",
          align: "left",
          sortable: true
        },

        {
          title: this.$t("pageLanguage.correspondence"),
          key: "Schriftverkehr",
          align: "left",
          sortable: true
        },
        {
          title: this.$t("pageLanguage.accounting"),
          key: "Buchhaltung",
          align: "left",
          sortable: true
        },
        {
          title: this.$t("pageLanguage.personal"),
          key: "Personal",
          align: "left",
          sortable: true
        },
        {
          title: this.$t("pageLanguage.contracts"),
          key: "Vertrage",
          align: "left",
          sortable: true
        },
        {
          title: this.$t("pageLanguage.chancery_post"),
          key: "Kanzleipost",
          align: "left",
          sortable: true
        },
        {
          title: this.$t("pageLanguage.private"),
          key: "Personliches",
          sortable: true,
          align: "left"
        },
        {
          title: "Archiv",
          key: "Archiv",
          sortable: true,
          align: "left"
        },
        {
          title: this.$t("pageLanguage.missing_barcodes"),
          key: "unusedBarcode",
          sortable: true,
          align: "left"
        },
        {
          type: "refresh",
          width: 15,
          align: "right"
        },
        {
          type: "expand",
          width: 25,
          align: "right",

          render: (h, params) => {
            return h(TableExpand, {
              props: { row: params.row }
            });
          }
        }
      ];
      this.shortcuts = [
        {
          text: this.$t("pageLanguage.Last_three_days"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 3 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        },
        {
          text: this.$t("pageLanguage.Last_seven_days"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 7 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        },
        {
          text: this.$t("pageLanguage.Last_month"),
          onClick() {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() - 30 * 24 * 3600 * 1000);
            const date = [end, start];
            return date;
          }
        }
      ];
    },
    date() {
      this.startDate = this.convertDateStart(this.date[0]);
      this.endDate = this.convertDateFinish(this.date[1]);
      this.isUseDatepicker = true;
      this.apiMethods();
    },
    getCliendListData() {
      if (this.$store.getters.showRepoClientList.data != null) {
        this.isLoading = false;
        this.isShowNoDataimg = false;
        this.isShowFilterimg = false;
        this.isUseDatepicker = false;
      }
      if (this.$store.getters.showStatus == "error") {
        if (this.isUseDatepicker == true) {
          this.isShowFilterimg = true;
          this.isUseDatepicker = false;
          this.isShowNoDataimg = false;
          this.isLoading = false;
        }
      }
      if (
        this.startDate == null &&
        this.endDate == null &&
        this.$store.getters.showRepoClientList.data != null
      ) {
        this.isShowDatetext = false;
        this.isShowFilterimg = false;
        this.isShowNoDataimg = false;
        this.$store.commit("addStatus", "acsess");
      }
    },
    currentPage() {
      this.getPageData = `${this.currentPage}?limit=${this.perPage}`;
      this.isLoading = true;

      this.apiMethods();
    },
    perPage() {
      this.getPageData = `${this.currentPage}?limit=${this.perPage}`;
      console.log(this.perPage);
      if (this.perPage != "10") this.tableRefreshIcon = true;
      else this.tableRefreshIcon = false;
      this.isLoading = true;
      this.apiMethods();
    }
  },
  created() {
    this.getPageData = `${this.currentPage}?limit=${this.perPage}`;
    this.getQuary();
    this.startToOneWeekFilter();
    this.apiMethods();
    this.columns = [
      {
        type: "selection",
        width: 40,
        align: "center"
      },

      {
        filteredValue: ["ie"],
        title: this.$t("pageLanguage.consultant_no_client_no"),
        key: "cc",
        resizable: true,
        align: "left",
        sortable: true,
        search: true,
        searchQuery: this.filterQuery,
        filterMultiple: false,
        filters: forStrings,
        async filterRemote(option, query) {
          this.ccquary = query;
          this.ccoption = option;
          this.isUseFilterQuary = true;
          if (query.length < 1) {
            this.isUseFilterQuary = false;
          }
          await this.sleep(2000);
          this.apiMethods()();
        }
      },
      {
        filteredValue: ["ie"],
        tooltip: true,
        title: this.$t("pageLanguage.client_name"),
        key: "name",
        resizable: true,
        align: "left",
        sortable: true,
        search: true,
        searchQuery: this.filterQuery,
        filterMultiple: false,
        filters: forStrings,
        async filterRemote(option, query) {
          this.namequary = query;
          this.nameoption = option;
          this.isUseFilterQuary = true;
          if (query.length < 1) {
            this.isUseFilterQuary = false;
          }
          await this.sleep(2000);
          this.apiMethods();
        }
      },
      {
        title: this.$t("pageLanguage.last_upload_on"),
        key: "documentDate",
        slot: "documentDate",
        align: "left",
        sortable: true
      },

      {
        title: this.$t("pageLanguage.correspondence"),
        key: "Schriftverkehr",
        align: "left",
        sortable: true
      },
      {
        title: this.$t("pageLanguage.accounting"),
        key: "Buchhaltung",
        align: "left",
        sortable: true
      },
      {
        title: this.$t("pageLanguage.personal"),
        key: "Personal",
        align: "left",
        sortable: true
      },
      {
        title: this.$t("pageLanguage.contracts"),
        key: "Vertrage",
        align: "left",
        sortable: true
      },
      {
        title: this.$t("pageLanguage.chancery_post"),
        key: "Kanzleipost",
        align: "left",
        sortable: true
      },
      {
        title: this.$t("pageLanguage.private"),
        key: "Personliches",
        sortable: true,
        align: "left"
      },
      {
        title: "Archiv",
        key: "Archiv",
        sortable: true,
        align: "left"
      },
      {
        title: this.$t("pageLanguage.missing_barcodes"),
        key: "unusedBarcode",
        sortable: true,
        align: "left"
      },

      {
        type: "refresh",
        width: 15,
        align: "right"
      },
      {
        type: "expand",
        width: 25,
        align: "right",

        render: (h, params) => {
          return h(TableExpand, {
            props: { row: params.row }
          });
        }
      }
    ];
    this.$store.dispatch("addPerPageAction", this.getPageData);
  }
};
</script>

<style lang="scss">
.dp-table-overflowY {
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 5px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #9b9b9b;
    border-radius: 5px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #9b9b9b;
  }
}

//!--------------
@media only screen and (min-width: 500px) {
  .no-Document {
    left: 5% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 600px) {
  .no-Document {
    left: 10% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 700px) {
  .no-Document {
    left: 15% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 800px) {
  .no-Document {
    left: 20% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 900px) {
  .no-Document {
    left: 25% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 1000px) {
  .no-Document {
    left: 30% !important;
    top: 40% !important;
  }
}
@media only screen and (min-width: 1100px) {
  .no-Document {
    left: 35% !important;
    top: 40% !important;
  }
}
.no-Document {
  position: absolute;
  align-items: center;
  justify-content: center;
  text-align: center;
  .descirpt1 {
    margin-top: 4rem;
    color: #174171;
    font-weight: bold;
  }
  .descirpt2 {
    color: #174171;
    font-weight: 500;
  }
}

//! --------------------------------

#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-body
  > table
  > tbody
  > tr:nth-child(n)
  > td:not(dp-table-column-).dp-table-column-center
  > div
  > label
  > span {
  box-shadow: none !important;
  border-color: none !important;
}
.dp-table tr.dp-table-row-hover td tr .dp-table-cell {
  &:hover {
    background-color: transparent !important;
  }
}
dp-table-cell dp-table-body-cell {
  &:hover {
    background-color: transparent !important;
  }
}
#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-header
  > table
  > thead
  > tr
  > th:nth-child(15) {
  z-index: -1 !important;
  display: none !important;
}

input[type="checkbox"]:focus + .dp-checkbox--check.dp-checkbox--primary {
  border-color: #dbdbdb !important;
}

#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div.table.dp-table-wrapper
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-header
  > table
  > thead
  > tr
  > th.dp-table-column-center
  > div
  > label
  > span {
  box-shadow: none;
}

.dp-checkbox--check {
  border: 1px solid #dbdbdb;
}
.dp-table-overflowY {
  overflow-x: hidden !important;
}
.table_header {
  justify-content: space-between;
  display: flex;
  margin: 0px 20px;
  .table_header-right {
    color: #1b4073;
    font-size: 13px;
    font-weight: 600;
  }
  .table_header-left {
    width: 59px;
    height: 18px;
    color: #4f8ee6;
    font-size: 13.5px;
    font-weight: 500;
    line-height: 18px;
    text-transform: uppercase;
    justify-items: space-between;
  }
}

.dp-table-header-cell--searchable {
  font-weight: 400 !important;
}
.dp-table-header-cell--filter-button {
  width: 32px !important;
  height: 32px !important;
  border: 4px solid #ffffff !important;
}
#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-body
  > table
  > tbody
  > tr:nth-child(n)
  > td.dp-table-column-left
  > div
  > * {
  padding-left: 0.5rem;
}

.date {
  margin-top: 20px;
  margin-bottom: 32px;
  margin-left: 20px;
  width: 330px;
  height: 36px;
}
.dp-input_wrapper {
  background-color: white;
}

.detail {
  margin: 0px 20px;
  .dp-table-body-cell {
    background-color: #ffff;
    height: 2.6rem !important;
    border: 0px solid #e0e0e0 !important;
  }
  .dp-table-header thead tr th .dp-table-header-cell {
    border: none;
    border-radius: 0.25rem;
  }
  .dp-table-header thead tr th .dp-table-header-cell--without-search {
    background: rgba(216, 216, 216, 0.2) !important;
  }
}
#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-header
  > table
  > thead
  > tr
  > th:not(.dp-table-column-).dp-table-column-right {
  position: absolute !important;
  cursor: pointer !important;
  height: auto !important;
  width: auto !important ;
  right: 5px !important;
}
#report
  > div.home_conteiner
  > div.table
  > div.detail
  > div.table-refresh-icon
  > div.dp-table.dp-table-default.dp-table-with-fixed-top
  > div.dp-table-header
  > table
  > thead
  > tr
  > th:not(.dp-table-column-).dp-table-column-right {
  right: 12px !important;
}
.dp-table-header thead tr th {
  width: 100% !important ;
}
.dp-table-cell-expand {
  line-height: 0px;
  i {
    font-size: 1.25rem;
  }
}

.pagination {
  position: absolute;
  align-items: center;
  display: flex;
  bottom: 0;
  z-index: 3;
  background-color: #f5f5f5;
  width: 100%;
  .dp-pagination--options {
    margin-left: 20px;
  }
  .home-dothSupport-item {
    cursor: pointer;
    display: flex;
    .home-doth {
      color: #9b9b9b;
      margin: 0 20px;
    }
    .support-icon {
      margin-right: 4px;
      font-size: 20px;
    }
    .home-support {
      display: flex;
      align-items: center;
      color: #4a90e2;
      font-weight: 600;
      font-size: 13.5px;
      margin-right: 20px;
    }
  }
}
div.home_conteiner
  > div.pagination
  > ul
  > div.dp-pagination--options
  > div
  > div.dp-dropdown
  > ul.dp-dropdown-menu {
  display: flex;
  flex-direction: row !important;
  transform: translate3d(-35px, -60px, 0px) !important;
}
.dp-table-row {
  & > td > div:nth-child() {
    height: 60px !important;
  }
}
.dp-table-row-hover > td > div:first-child {
  background-color: #fff !important;
}

.dp-loader--xlarge {
  position: absolute !important;
  z-index: 10 !important;
  margin: 15% 45%;
  > svg {
    width: 2.75rem;
    height: 2.75rem;
  }
}
</style>
